if (!customElements.get('dl-status-refresh')) {
  customElements.define(
    'dl-status-refresh',
    class DlStatusRefresh extends HTMLElement {
      connectedCallback() {
        const configuredInterval = Number.parseInt(this.dataset.refreshInterval, 10);
        this.refreshInterval = Number.isFinite(configuredInterval) ? configuredInterval : 60000;
        window.clearInterval(this.refreshTimer);
        this.refreshStatus();
        this.refreshTimer = window.setInterval(() => this.refreshStatus(), this.refreshInterval);
      }

      disconnectedCallback() {
        window.clearInterval(this.refreshTimer);
      }

      async refreshStatus() {
        if (this.refreshing || document.hidden || !this.dataset.sectionId) return;

        this.refreshing = true;

        try {
          const requestUrl = new URL(window.location.href);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);
          requestUrl.searchParams.set('_status_refresh', Date.now().toString());

          const response = await fetch(requestUrl.toString(), {
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) return;

          const responseHtml = await response.text();
          const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
          const nextStatus = responseDocument.querySelector('dl-status-refresh .dl-top-level-status');
          const currentStatus = this.querySelector('.dl-top-level-status');

          if (nextStatus && currentStatus) {
            this.updateServerTime(nextStatus, response);
            currentStatus.replaceWith(nextStatus);
          }
        } catch {
          // Keep the currently rendered status if the section request fails.
        } finally {
          this.refreshing = false;
        }
      }

      updateServerTime(statusElement, response) {
        const responseDate = response.headers.get('date');
        if (!responseDate) return;

        const responseAge = Number.parseInt(response.headers.get('age') || '0', 10);
        const ageMilliseconds = Number.isFinite(responseAge) ? responseAge * 1000 : 0;
        const serverTimestamp = Date.parse(responseDate) + ageMilliseconds - 60000;
        if (!Number.isFinite(serverTimestamp)) return;

        const updatedElement = statusElement.querySelector('.dl-top-level-status-updated');
        if (!updatedElement) return;

        const date = new Date(serverTimestamp);
        const dateText = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        }).format(date);
        const timeText = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        }).format(date);
        const prefix = updatedElement.dataset.updatedPrefix || 'Last updated';
        const timezoneLabel = updatedElement.dataset.timezoneLabel;

        updatedElement.textContent = `${prefix} ${dateText} — ${timeText}${timezoneLabel ? ` ${timezoneLabel}` : ''}`;
      }
    }
  );
}
